import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import DeleteButtonComponent from './component'

export const Delete = combine(
  withTableController({ id: 'sponsors-table' }),
  withContext('appStore', StoreContext),
  withContext(
    'adminSponsorsService',
    ServicesContext,
    ({ adminSponsorsService }) => adminSponsorsService
  ),
  withCallback(
    'onDeleteSponsorById',
    ({ adminSponsorsService, table }, { value }) =>
      () => {
        adminSponsorsService
          .removeSponsorById(value.id)
          .then(() => table.refresh())
      },
    ['value']
  )
)(DeleteButtonComponent)
